import { render } from "./MaoLoader.vue?vue&type=template&id=6acc9b0c&scoped=true"
import script from "./MaoLoader.vue?vue&type=script&lang=js"
export * from "./MaoLoader.vue?vue&type=script&lang=js"

import "./MaoLoader.vue?vue&type=style&index=0&id=6acc9b0c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6acc9b0c"]])

export default __exports__